export default "__VITE_ASSET__B6PkaOIB__"